const getList = {
  nNutritionRawInfoPage:"/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawInfoWithoutSpecialTypePage",
  factoryRaw: "/nhf-app/factoryRaw/page",
  nutritionPage: "/nhf-app/factorystaffnutritionraw/selectNutritionPage",
  ratioDetailList: "/nhf-app/ratiodetail/list", // 配方表分页
  ratioDetailPage: "/nhf-app/ratiodetail/page", // 配方表分页
  formulaRawNhfDetail: "/nhf-app/formulaManage/detail", // 配方详情
  mixDetail: "/nhf-app/formulaextmix/detail", // 配方详情
  formulaModel: "/nhf-nhmodel/formulamodel/UserInfopage", // Hmodel模型
  productionForecast:'/nhf-app/productionforecast/page', // 预计生产量
  factoryList:'/nhf-app/formulaManage/myFactory',
  customerPage:'/nhf-custom/customer/page', // 客户名称列表
  selectFactoryStaffNutritionRawMoistureVolatilizePage:"/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawMoistureVolatilizePage",
  // 定制料
  customformulaDetail: '/nhf-custom/customformula/detail', // 定制料-查详情
  getCustomer: '/nhf-custom/customer/page', // 定制料-客户下拉列表
  customLinearOptimizationByOpt: '/nhf-custom/customFormulaRemoteCal/customLinearOptimizationByOpt', // 定制料-配方优化
  getNutritionContrastcustom: '/nhf-custom/custompro/getNutritionContrast', // 定制料-配方详情-产品对比-营养需要量
  myCustomerRawPage: '/nhf-custom/custfactorystaffraw/myCustomerRawPage', // 定制料-配方详情-保存为原料-原料列表
  selectCustomFormulaNutritionToRawPage: '/nhf-custom/customformula/selectCustomFormulaNutritionToRawPage', // 定制料-配方营养需要量-指标名称查原料
  selectFormulaProductPageByCond: '/nhf-app/formulaproduct/selectFormulaProductPageByCond', // 产品对比-查询激活产品
  checkCreatePro: '/nhf-app/formulaproductext/checkCreatePro', // 验证配方
  distributionDetail: '/nhf-app/formuladistributiondiff/detail', // 配销差详情

  pushFormulaRecordRaw: '/nhf-value-estimate/pushformularecordraw/viewPushFormulaRecordRaw', // 任务配方原料
  pushFormulaRecordNutritionAll: '/nhf-value-estimate/pushformularecordnutritionall/viewPushFormulaRecordNutritionAll', // 任务配方营养需要量

  getSelectTagPageByCond: '/nhf-core-data/tag/selectTagPageByCond', // 获取配方模型tag标签
  modelList: '/nhf-nhmodel/formulamodel/app/userPage', // 获取配方模型
}

const getArrayForm = {
  batchFormulaRawEbsCheck: '/nhf-app/formulaNhf/batchFormulaRawEbsCheck', // ebs校验
  contrastTargetModelAddDiff: '/nhf-app/formulaManage/contrastTargetModelAddDiff', // 刷新版本
  getNutritionContrast: '/nhf-app/formulaNhf/getNutritionContrast',
  formulaReportUrl: "/nhf-app/formulaNhf/formulaReportUrl",
  formulaMixReportUrl: "/nhf-app/formulaextmix/formulaMixReportUrl", // 混合日粮-  报表路径
  myFormulaNhfPage: "/nhf-app/formulaManage/myFormulaNhfPage", // 配方信息分页查询
  formulaRawNhfPage: "/nhf-app/formulaNhf/formulaRawNhfPage", // 配方原料分页查询
  mixRawNhfPage: "/nhf-app/formulaNhf/formulaRawNhfPage", // 混合日粮-查看分页查询
  formulaMixRawNhfPage: '/nhf-app/formulaSelfRaw/formulaSelfRawNhfPage', // 日粮分页查询
  // mixBlendPage: 'nhf-app/formulaNhf/formulaNutritionNhfPage', // 补充料分页查询
  formulaNutritionNhfPage: "/nhf-app/formulaNhf/formulaNutritionNhfPage", // 配方营养指标分页查询
  mixNutritionNhfPage: "/nhf-app/formulaNhf/formulaNutritionNhfPage", // 混合日粮查看分-营养指标分页查询
  formulaMixNutritionNhfPage: '/nhf-app/formulaNhf/formulaMixNutritionNhfPage',
  supplementPage: '/nhf-app/formulaNhf/formulaNutritionNhfPage',
  animalTypeList: "/iot-factory/FactoryAnimal/listByParentId", // 动物类型(新)
  nutritionRawPage: "/nhf-app/nutritionMage/nutritionRawPage", // 营养营养指标列表
  factoryRawPage: "/nhf-app/factoryRaw/page", //基础原料列表
  // listByParentId: "/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId", //基础分类
  listByParentId: "/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit", //基础分类
  myRawPageWithStatus: "/nhf-app/factorystaffraw/myRawPageWithStatus", // 我的原料条件(状态)分页查询
  myRawpage: "/nhf-app/factorystaffraw/myRawpage", // 添加原料的列表
  mixAddRawPage : '/nhf-app/factorystaffraw/selectRawExceptMixPageUp',
  mixAddBlendPage: '/nhf-app/factorystaffraw/myRawpage',
  selectFormulaRawNutritionDetailPage: "/nhf-app/formulaManage/selectFormulaRawNutritionDetailPage", //养分控制-原料
  animalNutritionUserPage:"/nhf-core-data/animalnutrition/animalNutritionUserPage",
  equationList: "/nhf-fine/equation/list", // 方程列表
  listAnimalUserByParentId: "/nhf-core-data/animal/listAnimalUserByParentId",
  nutritionTypeInfoPage: "/nhf-core-data/animalnutritionlink/typeInfoPage",
  selectFormulaNutritionToRawPage:"/nhf-app/formulaManage/selectFormulaNutritionToRawPage",
  selectFormulaMixNutritionToRawPage:"/nhf-app/formulaextmix/selectFormulaMixNutritionToRawPage", // 混合日粮-合计，补充料查询
  linearOptimization: "/nhf-app/formulaRemoteCal/linearOptimization",
  linearOptimizationByOptimization:"/nhf-app/formulaRemoteCal/linearOptimizationByOptimization",
  mixLinearOptimizationByOptimization:"/nhf-app/formulaRemoteCal/mixLinearOptimizationByOptimization", // 混合日粮-配方优化
  formulaNoticePageList: "/nhf-app/formulanotice/formulaNoticePageList",
  getFormulaHisVersionList: "/nhf-app/formulahis/getFormulaHisVersionList",
  activationFormulaHisVersion: "/nhf-app/formulahis/activationFormulaHisVersion",// 混合日粮切换版本
  activationFormulaMixHisVersion: "/nhf-app/formulaextmixhis/activationFormulaMixHisVersion", // 混合日粮切换版本（新）
  formulataskDetail:'/nhf-app/formulatask/detail',
  formulaSpeedTaskDetail:'/nhf-app/formulaspeedtask/detail',
  selectFormulaTaskFormulaHaveSolutionPage:'/nhf-app/formulataskformula/selectFormulaTaskFormulaHaveSolutionPage',
  // 定制料
  getCustomFormulaRaw: '/nhf-custom/customformula/getCustomFormulaRaw', // 定制料-配方原料列表
  getCustomFormulaNutrition: '/nhf-custom/customformula/getCustomFormulaNutrition', // 定制料-配方营养需要量-列表
  customGetProductPrice: '/nhf-custom/custompro/getProductPrice', // 定制料-查询产品价格
  suboptimalByOptimization: '/nhf-app/formulaRemoteCal/suboptimalByOptimization', // 次优解列表
}

const postArray = {
  batchUpdateFormulaStatus: '/nhf-app/formulaManage/batchUpdateFormulaStatus', // 配方显示隐藏
  nutritionraRemmove: "/nhf-app/factorystaffnutritionraw/remove",
  nutritionraUpdate: "/nhf-app/factorystaffnutritionraw/update",
  ratioDetailSave: "/nhf-app/ratiodetail/save", // 配方表保存
  ratioDetailUpdate: "/nhf-app/ratiodetail/update", // 配方表保存
  ratioDetailSubmit: "/nhf-app/ratiodetail/submit", // 配方表新增
  removeFormulaIds: "/nhf-app/formulaManage/removeFormulaIds", // 批量删除配方
  // removeMix: '/nhf-app/formulaextmix/remove',
  formulaManageSave: "/nhf-app/formulaManage/save",
  formulaBlendSave: "/nhf-app/formulaextmix/save",
  formulaManageUpdate: "/nhf-app/formulaManage/update", //基础信息编辑
  mixUpdate: "/nhf-app/formulaextmix/update", //基础信息编辑
  updateFormulaMixPrice: '/nhf-app/formulaextmix/updateFormulaMixPrice',// 修改价格计算相关价格
  saveFormulaRawIds: "/nhf-app/formulaManage/saveFormulaRawIds", //批量添加原料
  saveMixIds: "/nhf-app/formulaSelfRaw/saveFormulaSelfRawIds", //批量添加日粮
  // saveMixBlendIds: '/nhf-app/formulaManage/saveFormulaRawIds',
  formulaManageRemove: "/nhf-app/formulaManage/remove", //批量移除配方原料
  mixRemove: '/nhf-app/formulaSelfRaw/remove', //批量移除日粮
  mixBlendRemove: "/nhf-app/formulaManage/remove", //批量移除补充料
  saveFormulaNutritionId: "/nhf-app/formulaManage/saveFormulaNutritionId", // 添加配方营养指标
  saveFormulaMixNutritionId: "/nhf-app/formulaSelfRaw/saveFormulaMixNutritionId", // 应用养分选择表
  resetFormulaRawIds: "/nhf-app/formulaManage/resetFormulaRawIds", // 重置-配方原料
  resetFormulaNutritionIds: "/nhf-app/formulaManage/resetFormulaNutritionIds", //重置-配方营养需要量
  batchSaveRawNutritionIds:"/nhf-app/factorystaffnutritionraw/batchSaveRawNutritionIds",
  removeLogic: "/nhf-app/factorystaffraw/removeLogic",
  formularawUpdate: "/nhf-app/formularaw/update",
  formularawUpdateCache: "/nhf-app/formularaw/updateCache",
  mixRawUpdate: "/nhf-app/formulaSelfRaw/rawUpdate", // 日粮修改
  rawSelfUpdateCache: "/nhf-app/formulaSelfRaw/rawSelfUpdateCache",
  formulanutritionUpdate: "/nhf-app/formulanutrition/update",
  formulanutritionUpdateCache: "/nhf-app/formulanutrition/updateCache",
  updateMixNutrition: '/nhf-app/formulaSelfRaw/updateMixNutrition', // 合计 - tab合计修改
  updateMixNutritionCache: '/nhf-app/formulaSelfRaw/updateMixNutritionCache', // 合计 - tab合计缓存更新
  singleUpdateStaffNutritionRawListTab: '/nhf-app/formulaSelfRaw/updateMixNutrition',// 合计 - tab合计修改
  mixTotalUpdate: '/nhf-app/formulanutrition/update', // 合计 - 补充料修改
  mixTotalUpdateCache: '/nhf-app/formulanutrition/updateCache', // 合计 - 补充料缓存更新
  batchUpdateStaffNutritionRawList:"/nhf-app/factorystaffnutritionraw/batchUpdateStaffNutritionRawList",
  batchUpdateFormulaRawNutritionList:"/nhf-app/formularawnutrition/batchUpdateFormulaRawNutritionList",
  calculateNutritionraw: "/nhf-app/factorystaffnutritionraw/formulaCalculate",
  formulaEquationCalculateBackGround: "/nhf-app/factorystaffnutritionraw/formulaEquationCalculateBackGround",
  ladderAnalysis: "/nhf-app/formulaRemoteCal/ladderAnalysis",
  confirmCopyFormula: "/nhf-app/formulaManage/confirmCopyFormula",
  confirmCopyFormulaMix: "/nhf-app/formulaManage/confirmCopyFormulaMix", // 混合日粮复制
  rawEquationCalculateBackGround:"/nhf-app/factorystaffnutritionraw/rawEquationCalculateBackGround",
  saveFormulaTask: "/nhf-app/formulatask/saveFormulaTask", // 新增旧版多配方任务
  formulataskUpdate: '/nhf-app/formulatask/update',
  saveFormulaSpeedTask: "/nhf-app/formulaspeedtask/saveFormulaSpeedTask", // 新增新版本多配方任务
  formulataskSpeedUpdate: '/nhf-app/formulaspeedtask/updateSpeedFormulaTask',
  updateFactoryStaffRawPrice: '/nhf-app/factorystaffraw/updateFactoryStaffRawPrice',
  saveAsRawInfo:'/nhf-app/formulaManage/saveAsRawInfo',
  singleUpdateStaffNutritionRawList:'/nhf-app/factorystaffnutritionraw/singleUpdateStaffNutritionRawList',
  singleAutoUpdateStaffNutritionRawList: '/nhf-app/factorystaffnutritionraw/singleAutoUpdateStaffNutritionRawList',
  // singleUpdateStaffNutritionRawList: '/nhf-app/factorystaffnutritionraw/singleUpdateStaffNutritionRawList', // 合计 - 合计修改
  updateFormulaFormulaSolutionType: '/nhf-app/formulaManage/updateFormulaFormulaSolutionType',
  // 定制料
  saveCustomFormula: '/nhf-custom/customformula/saveCustomFormula',  // 定制料-新增
  getCustomFormulaPage: '/nhf-custom/customformula/getCustomFormulaPage', // 定制料-列表
  removeCustomFormulaByIds: '/nhf-custom/customformula/removeCustomFormulaByIds', // 定制料-列表删除
  updateCustomFormula: '/nhf-custom/customformula/updateCustomFormula', // 定制料-修改
  getAddCustomFormulaRawList: '/nhf-custom/customformularaw/getAddCustomFormulaRawList', // 定制料-新增原料列表
  saveCustomFormulaRawIds: '/nhf-custom/customformula/saveCustomFormulaRawIds', // 定制料-配方原料-新增
  removeCustomFormulaRaws: '/nhf-custom/customformula/removeCustomFormulaRaws', // 定制料-配方原料-删除
  getNotInCustomProLibPageByCond: '/nhf-custom/customprolib/getNotInCustomProLibPageByCond',// 定制料-配方原料-导入产品库-产品库列表
  getNonInCustomFormulaProductPageByCond: '/nhf-custom/custompro/getNonInCustomFormulaProductPageByCond',// 定制料-配方原料-导入产品库-工厂产品列表
  getNotInCustomProPageByCond: '/nhf-custom/custompro/getNotInCustomProPageByCond',// 定制料-配方原料-导入产品库-定制料产品列表
  updateCustFactoryStaffRawPrice: '/nhf-custom/custfactorystaffraw/updateCustFactoryStaffRawPrice', // 定制料-配方原料-修改价格
  updateCustomFormulaRawProPrice: '/nhf-custom/customformularawpro/updateCustomFormulaRawProPrice', // 定制料-配方原料-修改产品价格
  updateCustomFormulaRaw: '/nhf-custom/customformularaw/updateCustomFormulaRaw', // 定制料-配方原料-修改限制
  saveCustomFormulaRawProIds: '/nhf-custom/customformula/saveCustomFormulaRawProIds', // 定制料-导入产品库-新增
  updateCustomFormulaSolutionType: '/nhf-custom/customformula/updateCustomFormulaSolutionType', // 定制料-配方详情-修改状态
  updateCustomFormulaNutrition: '/nhf-custom/customformulanutrition/updateCustomFormulaNutrition', // 定制料-配方营养需要量-修改限制值
  getCustFactoryStaffNutritionRawMoistureVolatilizePage: '/nhf-custom/customformula/getCustFactoryStaffNutritionRawMoistureVolatilizePage', // 定制料-配方原料-原料详情
  selectCustFactoryStaffNutritionRawInfoWithoutSpecialTypePage: '/nhf-custom/custfactorystaffnutritionraw/selectCustFactoryStaffNutritionRawInfoWithoutSpecialTypePage', // 定制料-配方原料-原料详情
  getCustomProMoistureVolatilizePage: '/nhf-custom/customformula/getCustomProMoistureVolatilizePage', // 定制料-配方原料-产品详情
  singleAutoUpdateStaffCustNutritionRawList: '/nhf-custom/custfactorystaffnutritionraw/singleAutoUpdateStaffCustNutritionRawList', // 定制料-配方原料-原料详情-修改
  batchUpdateStaffNutritionRawListCustom: '/nhf-custom/custfactorystaffnutritionraw/batchUpdateStaffNutritionRawList', // 定制料-原料配方-原料详情-全量替换
  custRawEquationCalculateBackGround: '/nhf-custom/custfactorystaffnutritionraw/custRawEquationCalculateBackGround', // 定制料-原料配方-原料详情-计算
  saveCustomFormulaAsRaw: '/nhf-custom/customformula/saveCustomFormulaAsRaw', // 定制料-配方详情-保存为原料
  updateCustomFormulaLink: '/nhf-custom/customformula/updateCustomFormulaLink', // 定制料-配方详情-配方营养需要量-养分选择表-替换养分选择表
  updateCustomFormulaPrice: '/nhf-custom/customformula/updateCustomFormulaPrice', // 定制料-配方详情-修改价格
  generateCustomFormulaRecipe: '/nhf-custom/customformula/generateCustomFormulaRecipe', // 定制料-配方详情-查看报表
  updateSortNum: '/nhf-app/formulaManage/updateSortNum', // 配方-列表-排序
  customUpdateSortNum: '/nhf-custom/customformula/updateSortNum', // 定制料-列表-排序
  getCustomProPageByCond: '/nhf-custom/custompro/getCustomProPageByCond', // 定制料-产品对比-查询激活状态产品名称
  confirmCopyCustomFormula: '/nhf-custom/customformula/confirmCopyCustomFormula', // 定制料-复制

  // OEM代工配方


  getFormulaDistributionDiffListByIds: '/nhf-app/formuladistributiondiff/getFormulaDistributionDiffListByIds', // 配销差列表获取
  batchUpdateFormulaDistributionDiff: '/nhf-app/formuladistributiondiff/batchUpdateFormulaDistributionDiff', // 批量设置配销差
  updateOnlyFormulaDistributionDiffPrice: '/nhf-app/formuladistributiondiff/updateOnlyFormulaDistributionDiffPrice', // 配销差修改
  updateOnlyFormulaDistributionDiffReferPrice: '/nhf-app/formuladistributiondiff/updateOnlyFormulaDistributionDiffReferPrice', // 配销差参考价格修改
  updateFormulaReferPrice: '/nhf-app/formulaManage/updateFormulaReferPrice', // 计算产品成本
  saveSuboptimalRaw: '/nhf-app/formulaRemoteCal/saveSuboptimalRaw', // 次优解保存原料
  saveSuboptimalNutrition: '/nhf-app/formulaRemoteCal/saveSuboptimalNutrition', // 次优解保存指标
  updateFormulaTypeClassify: '/nhf-app/formulaManage/updateFormulaTypeClassify', // 更新配方分类
  updateFormulaMixConstraintOptions: '/nhf-app/formulaextmix/updateFormulaMixConstraintOptions', // 更改


  pushedFormulaList: '/nhf-value-estimate/pushformularecord/pagePushFormulaRecord', // 任务配方推送记录列表
  delPushFormulaRecord: '/nhf-value-estimate/pushformularecord/delPushFormulaRecord', // 删除推送记录
  importPushFormula: '/nhf-app/formulaManage/importPushFormula', // 导入推送配方
  pushFormulaCreatePro: '/nhf-app/formulaproduct/pushFormulaCreatePro', // 推送配方生成产品
  coverFormula: "/nhf-app/formulaManage/coverFormula",

  // RMP
  getFormulaRmpResult: '/nhf-app/formularmpresult/pageFormulaRmpResult',
  bindFormulaRmpResult: '/nhf-app/formularmpresult/bindFormulaRmpResult',
  updateRawFixRatioList: '/nhf-app/formulaNhf/updateRawFixRatioList',//更新原料系数
}

const postFormArray = {
  selectLineAnimalByAnimalId: '/nhf-core-data/lineAnimal/selectLineAnimalByAnimalId',
  formulaReportPdf: "/nhf-app/formulaNhf/formulaReportPdf",
  formulaReport: "/nhf-app/formulaNhf/formulaReport",
  removeMix: '/nhf-app/formulaextmix/remove',
  ratioDetailRemove: "/nhf-app/ratiodetail/remove",
  saveProVersion: "/nhf-app/formulaManage/saveProVersion",
  getProductContrast: "/nhf-app/formulahis/getProductContrast",
  getMixProductContrast: "/nhf-app/formulahis/getProductContrast", // 混合日粮-产品对比
  saveFormulaProduct: "/nhf-app/formulahis/saveFormulaProduct",
  saveMixFormulaProduct: "/nhf-app/formulaextmixhis/saveFormulaMixProduct", // 混合日粮-更新版本
  getProductPrice: "/nhf-app/formulahis/getProductPrice",
  updateFormulaNoticeStatus: "/nhf-app/formulanotice/updateFormulaNoticeStatus",
  linearOptimization: "/nhf-app/formulaRemoteCal/linearOptimization",
  copyFormula: "/nhf-app/formulaManage/copyFormula",

  saveFormulaInfoPro:"/nhf-app/formulaproduct/saveFormulaInfoPro",
  saveMixFormulaInfoPro:"/nhf-app/formulaproduct/saveFormulaMixInfoPro", // 混合日粮-生成产品
  // 验证配方代码是否唯一
  checkFormulaCodeIsUnique:"/nhf-app/formulaManage/checkFormulaCodeIsUnique",
  batchDelFormulaHisVersion: '/nhf-app/formulahis/batchDelFormulaHisVersion',// 版本批量删除
  // 定制料
  saveCustomPro: '/nhf-custom/custompro/saveCustomPro', // 定制料-配方详情-生成产品
  getCustomProRawContrast: '/nhf-custom/custompro/getCustomProRawContrast', // 定制料-配方详情-产品对比-原料
}

const baseApi = (arr, method) => {
  let list = {}
  for (let i in arr) {
    list[i] = async (data) => method(arr[i], data)
  }
  return list
}
import { get, getForm, post, postForm } from "../../Utils/axios"
import { mapState,mapMutations,mapGetters } from 'vuex'

import {modelIds} from './model'

export const nhfMixins = {
  data() {
    return {
      raw: [],
      model: {
        records: [],
      },
      list: {
        records: [],
      },
      price: ["合同价格", "预测价格", "库存价格", "市场价格"],
      rawTypes:[ '所有原料','组分原料','拒绝原料' ],
      classNames: ['未分类','自产配方','代工配方','定制配方'],
      rawTypesRadio:[
        { label: '所有原料', value: 0 },
        { label: '组分原料', value: 1 },
        { label: '拒绝原料', value: 2 },
      ],
      priceOption: [
        { label: "合同价格", value: '1' },
        { label: "预测价格", value: '2' },
        { label: "库存价格", value: '3' },
        { label: "市场价格", value: '4' },
      ],
      modelDetail: {},
      nutrition: [],
      modelLoading: false,
      updateLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      totalPercentage: 0,
      totalCost: 0,
      alertFlag:false,
      pagination: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      factoryId: null,
      bodyStyle: {
        padding: "0 15px 15px",
      },
      modalBodyStyle:{padding:'10px'},
      currentPage: {
        current: 1,
        size: 20,
      },
      modalVisible:false,
      maxLen: 100,
      isFullScreen: false,
      ImportProductLibraryLoading: false, // 导入产品库loading
      ImportProductFactoryLoading: false, // 导入工厂 loading
      ImportProductCustomizedLoading: false, // 导入定制料产品loading
      lineLoading: false,
      deleteIds: [ // 动物类型-过滤
        '1386959577212752019', // 肉牛-哺乳期犊牛 4.2.1
        '1386959577212752020', // 肉牛-生长期犊牛 4.2.2
        '1386959577212752021', // 肉牛-育成牛     4.2.3
        '1386959577212752022', // 肉牛-育肥肉牛   4.2.4
        '1386959577212752023', // 肉牛-种公牛     4.2.5
      ],
      modelIds,
    }
  },
  mounted() {
    this.formulaId = this.$route.query && this.$route.query.id ? this.$route.query.id : null
    this.factoryId = window.localStorage.getItem("factoryId") || null
    document.addEventListener('fullscreenchange',this.logFullScreen)
  },

  computed:{
    ...mapState('nhf',[
      'getListFlag',
      'rawSelect',
      'nutSelect',
      'layout',
      'detail',
      'height',
      'leftBoxTopHeight',// 左上表格高度
      'leftBoxBottomHeight', // 左下表格高度
      'visible',
      'nutRows',
      'rawRows',
      'rawResult',
      'nutVisible',
      'rightWidth',// 可拖拽框右侧宽度
      'leftWidth',// 可拖拽框左侧宽度
      'calculaVisible',
      'rawTableColShow',
      'nutTableColShow',
      'rawTypeSelect',
      'indexFilter',
      'formulaList',
      'rawEditors',
      'rawEditors2',
      'nutritionEditor',
      'nutritions',
      'getVisionRaw',
      'nutritionList',
      'referPriceSourceChange',
      'priceSourceChange',
      'setClassVisible',
    ]),
    ...mapGetters('nhf', [
      'nutColumnsValue',
      'rawColumnsValue',
      'rawEditorColumns',
      'rawEditor2Columns',
      'nutritionEditorColumns',
      'nutritionColumns'
    ])
  },

  methods: {
    ...mapMutations('nhf',[
      'setState',
      'toggleLayout',
      'toggleVisible'
    ]),
    getStatusColor(status) {
      const colorMap = {
        0: '#000000',    // 新建 - 黑色
        1: '#000000',    // 已测算 - 黑色
        86: '#FFB84D',    // 待审核 - 柔和黄色
        3: '#156627',    // 审核通过 - 绿色
        4: '#FF0000',    // 审核撤销 - 红色
        5: '#000000',    // 编辑中 - 黑色
      }
      return colorMap[status] || '#000000'
    },
    
    getStatusText(status) {
      const textMap = {
        0: '新建',
        1: '已测算',
        86: '待审核',
        3: '审核通过',
        4: '审核撤销',
        5: '编辑中'
      }
      return textMap[status] || status
    },
    ...baseApi(getList, get),
    ...baseApi(getArrayForm, getForm),
    ...baseApi(postArray, post),
    ...baseApi(postFormArray, postForm),

    toggleModalVisible(){
      this.modalVisible = !this.modalVisible
    },
    // normal page
    pageSetting() {
      return {
        size: 20,
        current: 1,
      }
    },

    async fetchGet({ actions, name, data = {}, isList, loading }) {
      if (actions) {
        try {
          if (loading) this[loading] = true

          let params = isList ? { ...this.pageSetting(), ...data } : data
          const res = await actions(params)
          if (name){
            if(name === 'list'){
              this[name] = {records: []}
              this[name] = res.data
            }else if(name==='records'){
              this.list = {
                records: res.data
              }
            }else{
              if(data.feild === 'animal') {
                res.data.animal = [res.data.animalTypeCode];
                let {formulaExtMix} = res.data || {}
                let {selfProvidedProportion} = formulaExtMix || {}
                res.data.selfProvidedProportion = selfProvidedProportion
              }
              this[name] = res.data
            }
          }
          if (isList) this.setPager(res.data)
          if (!res.success && name) this.$message.warn(res.msg)
          return res
        } catch (error) {
          error.msg && this.$message.warn(error.msg)
        } finally {
          if (loading) this[loading] = false
        }
      }
    },

    async fetchPost({ actions, data, loading, name, showMessage = true,isList,hasRes,modalMsg }) {
      try {
        if (loading) this[loading] = true
        const res = await actions(data)
        let {success} = res
        if(showMessage && res.msg !== ""){
          if(modalMsg){
            if(success){
              this.$message.success(res.msg)
            }else{
              this.$warning({
                title: modalMsg,
                content: res.msg
              });
            }
          }else{
            this.$message[success ? 'success' : 'warning'](res.msg)
          }
        }
        if (name) this[name] = res.data
        if (isList) this.setPager(res.data)
        if(res.data) res.data.errorMsg = res.msg
        if(res.data) res.data.code = res.code
        if(hasRes){
          return res
        }else{
          return res.data
        }

      } catch (error) {
        if (name) this[name] = {records: []}
        error.msg && this.$message.warn(error.msg)
      } finally {
        if (loading) this[loading] = false
      }
    },

    // 设置分页
    setPager(res) {
      const { total, current, size: pageSize } = res
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ["10", "20", "30", "40", "50", "60", "100"],
        pageSize,
        total,
        current,
        showSizeChanger: true,
        showTotal: (total) => <div style="flex:1">共{total}条记录</div>,
      }
    },

    cleanSelect() {
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // onSelect(selectedRows) {
    //  this.selectedRows=[...this.selectedRows,...selectedRows]
    // },
    getCheckboxProps(record){
      return ({
        props: {
          disabled: this.selectedRowKeys.length >= 50 && !this.selectedRowKeys.includes(record.id)
        },
      })
    },
    // 全选
    onSelectChange(selectedRowKeys, selectedRows) {
      selectedRowKeys = selectedRowKeys.splice(0,50)
      this.selectedRowKeys = selectedRowKeys
      let arr = [...this.selectedRows, ...selectedRows]
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0]
      })
      if(this.list && this.list.records)this.list.records = [...this.list.records]
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
        this.alertFlag = true
      }
    },
    // 单选
    onSelect(record, selected){
      if(selected) {
        if(this.selectedRowKeys.length >= this.maxLen){
          this.$message.warning(`选中的原料不能超过${this.maxLen}条`)
        }else{
          if (this.selectedRowKeys.length < this.maxLen &&!this.selectedRowKeys.includes(record.id)) {
            this.selectedRowKeys.push(record.id);
            this.selectedRows.push(record)
          }
        }
      }else{
        this.selectedRowKeys = this.selectedRowKeys.filter(el => el !== record.id)
        this.selectedRows = this.selectedRows.filter(el => el.id !== record.id)
      }
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
        this.alertFlag = true
      }
    },
    onSelectAll(selected, selectedRows, changeRows){
      if (selected) {
        if(this.selectedRowKeys.length >= this.maxLen){
          this.selectedRowKeys = [];
          this.selectedRows = []
        }else{
          changeRows.forEach((el) => {
            if (this.selectedRowKeys.length < this.maxLen &&!this.selectedRowKeys.includes(el.id)) {
              this.selectedRowKeys.push(el.id);
              this.selectedRows.push(el)
            }
          });
        }
      } else {
        this.selectedRowKeys = [];
        this.selectedRows = []
      }
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
        this.alertFlag = true
      }
    },

    tablePageChange(page) {
      const { current = 1, pageSize: size } = page
      this.currentPage = {
        size,
        current,
      }
      return {
        size,
        current,
      }
    },
    fixedNumber(num, len) {
      return num ? Math.round((num + Number.EPSILON) * len) / len : undefined
    },
    // 乘法
    mul(...val) {
      const strVal = val[0].toString()
      const strValTwo = val[1].toString()
      const index = strVal.indexOf(".")
      const indexTwo = strValTwo.indexOf(".")
      const num = [0, 0]
      if (index > -1) {
        num[0] = strVal.length - 1 - index
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index
      }
      return (
        Math.round(
          val[0] * Math.pow(10, num[0]) * (val[1] * Math.pow(10, num[1]))
        ) / Math.pow(10, num[0] + num[1])
      )
    },
    // 加法
    add(...val) {
      let max = 0
      let count = 0
      for (let i = 0;i < val.length; i++) {
        const strVal = val[i].toString()
        const index = strVal.indexOf(".")
        let num = 0
        if (index > -1) {
          num = strVal.length - 1 - index
          max = num > max ? num : max
        }
      }
      for (let i = 0; i < val.length; i++) {
        count += Math.round(val[i] * Math.pow(10, max))
      }
      return count / Math.pow(10, max)
    },

    //减法
    sub(arg1,arg2){
      let r1,r2
      // ,m
      ,n;
      try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
      try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
      // m=Math.pow(10,Math.max(r1,r2));
      n=(r1>=r2)?r1:r2;
      return +(arg1-arg2).toFixed(n)
    },
    // 除
    div(val, valTwo = 100) {
      const strVal = val.toString()
      const strValTwo = valTwo.toString()
      const index = strVal.indexOf(".")
      const indexTwo = strValTwo.indexOf(".")
      const num = [0, 0]
      if (index > -1) {
        num[0] = strVal.length - 1 - index
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index
      }
      return (
        Math.round(val * Math.pow(10, num[0])) /
        (Math.round(valTwo * Math.pow(10, num[1])) *
          Math.pow(10, num[0] - num[1]))
      )
    },
    logFullScreen(){
      if(window.document.fullscreenElement){
        this.isFullScreen = true
      }else{
        this.isFullScreen = false
      }
    },
    full(){
      let fullScreen = window.document.documentElement
      if(!this.isFullScreen){
        if(fullScreen.requestFullscreen){
          fullScreen.requestFullscreen()
        }else if(fullScreen.msRequesFullscreen){
          fullScreen.msRequesFullscreen()
        }else if(fullScreen.mozRequesFllscreen){
          fullScreen.mozRequesFllscreen()
        }else if(fullScreen.webkitRequesFullscreen){
          fullScreen.webkitRequesFullscreen()
        }
      }else{
        if(window.document.exitFullscreen){
          window.document.exitFullscreen()
        }else if(window.document.webkitCancelFullscreen){
          window.document.webkitCancelFullscreen()
        }else if(window.document.mozCancelFullscreen){
          window.document.mozCancelFullscreen()
        }else if(window.document.msExitFullscreen){
          window.document.msExitFullscreen()
        }
      }
      // this.isFullScreen = !this.isFullScreen
    },
  },
}
